import { render, staticRenderFns } from "./FieldDegrees.vue?vue&type=template&id=0afefa3f&"
import script from "./FieldDegrees.vue?vue&type=script&lang=js&"
export * from "./FieldDegrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports